module.exports = __webpack_public_path__ + "img/icon_check_black.206b785f.svg";